<template>
    <div class="personnel-label-wrap" v-loading="loading">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left">
                <el-input placeholder="请输入标签名称" v-model="searchForm.keyword" class="filter-input" clearable @clear="handleClickSearch" @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="iconfont icon-sousuo"></i>
                </el-input>
            </div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" @click="handleClickLabelOperate">新增</el-button>
            </div>
        </div>

        <CustomVxeTable ref="tableRef" class="custom-table" id="personnelLabelTable" :tableData="labelTableData" :reduceHeight="reduceHeight" :isShowToolBar="true"
            :empty-render="{ name: 'NotData' }" :pagination.sync="pagination" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
            :customConfig="tableCustomConfig">
            <vxe-column field="name" title="标签名称" min-width="180" show-overflow>
                <template #default="{ row }">
                    <span>{{ row.name }}</span>
                </template>
            </vxe-column>
            <vxe-column field="desc" title="描述" min-width="498" show-overflow>
                <template #default="{ row }">
                    <span>{{ row.describe }}</span>
                </template>
            </vxe-column>
            <vxe-column field="user" title="关联人员" min-width="490" show-overflow>
                <template #default="{ row }">
                    <div v-if="row.users.length">
                        <span>{{
                        row.users.filter(item=> item && item.name)
                            .slice(0, 3)
                            .map((item) => item.name)
                            .join("，")
                    }}</span>
                    <span v-if="row.users.length > 3" style="margin-left:2px;">+{{row.users.length - 3}}</span>
                    </div>
                </template>
            </vxe-column>
            <vxe-column field="operate" title="操作" width="88" fixed="right">
                <template #default="{ row }">
                    <div class="table-operate-icon">
                        <i class="iconfont icon-bianji" @click="handleClickLabelOperate(row)"></i>
                        <i class="iconfont icon-shanchu1" @click="handleClickLabelDelete(row)"></i>
                    </div>
                </template>
            </vxe-column>
            <template #empty>
                <div class="custom-table-empty">
                    <div class="custom-table-empty-img"></div>
                    <p class="custom-table-empty-txt">暂无数据</p>
                </div>
            </template>
        </CustomVxeTable>

        <personnelLabelOperate :personnelLabelDialog.sync="personnelLabelDialog" v-if="personnelLabelDialog" :personnelLabelId="personnelLabelId" @success="getTableData" />
        <el-dialog title="" v-if="deletePersonnelLabelDialog" :visible.sync="deletePersonnelLabelDialog" width="390px" :before-close="handleDeletePersonnelLabelDialogClose"
            :close-on-click-modal="false" class="custom-dialog custom-tooltip-confirm-dialog personnel-label-tooltip-dilaog">
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">删除人员标签</p>
                    <p v-if="labelUseContent">
                        该人员标签已应用于审批流程中，点击
                        <el-button type="text" @click="handleClickSetApproval">【去设置】</el-button>进行更改，角色删除后无法恢复，确定要删除吗？
                    </p>
                    <p v-else>人员标签删除后无法恢复，确定要删除吗？</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleDeletePersonnelLabelDialogClose">取消</el-button>
                <el-button type="danger" @click="handleDeletePersonnelLabelDialogConfirm">删除</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import personnelLabelOperate from "./component/personnel_label_operate.vue";
import { PersonTagList, PersonTagDel,PersonTagDeleteCheck } from "@/api";
import {mapGetters, mapState} from "vuex";
export default {
    name: "PersonnelLabel",
    components: { CustomVxeTable, personnelLabelOperate },
    data() {
        return {
            loading: false,
            searchForm: {
                keyword: "",
            },
            labelTableData: [],
            labelUseContent: null,//"审批流程/权限管理",
            // 新增、编辑
            personnelLabelDialog: false,
            personnelLabelId: 0,
            // 删除
            deletePersonnelLabelDialog: false,

            tableCustomConfig: {
                storage: true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return this.labelTableData.length ? 218 : 172;
        },
        ...mapGetters(['hasPermission']),
        hasSetApproval() {
            return this.hasPermission('approval.admin', 'approval', 'Approve');
        },
    },
    created() {
        this.getTableData();
    },
    methods: {
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        getTableData() {
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.loading = true;
            PersonTagList(postData).then((res) => {
                if (res.code === 200) {
                    let { data, total } = res.data;
                    this.labelTableData = data;
                    this.pagination.total = total;
                }
                this.loading = false;
            });
        },
        handleClickLabelOperate(row) {
            this.personnelLabelId = row && row.id ? row.id : 0;
            this.personnelLabelDialog = true;
        },
        // 取设置审批
        handleClickSetApproval(){
            this.deletePersonnelLabelDialog = false;
            if(this.hasSetApproval){
                this.$router.push({
                    name: 'approveAdminManagement',
                    params: {
                        isPush: true
                    }
                })
            }else{
                this.$message.error('您没有权限')
            }
        },
        // 删除标签
        handleClickLabelDelete(row) {
            this.personnelLabelId = row.id;
            PersonTagDeleteCheck({ id: this.personnelLabelId }).then((res) => {
                if (res.code === 200) {
                    let { del,type } = res.data
                    this.labelUseContent = null
                    if(del == false && type == "approval"){
                      this.labelUseContent = type
                    }
                    this.deletePersonnelLabelDialog = true;
                }
            });
        },
        handleDeletePersonnelLabelDialogClose() {
            this.personnelLabelId = 0;
            this.deletePersonnelLabelDialog = false;
        },
        handleDeletePersonnelLabelDialogConfirm() {
            this.deletePersonnelLabelDialog = false;
            PersonTagDel({ id: this.personnelLabelId }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.personnelLabelId = 0;
                    this.getTableData();
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = val.pageSize;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
    },
};
</script>
<style lang="scss" scoped>
.personnel-label-wrap {
    padding: 16px;
}
</style>
<style lang="scss">
.personnel-label-tooltip-dilaog {
    .el-dialog__body {
        min-height: 130px;
        padding-bottom: 0 !important;

        .el-button--text {
            padding: 0;
            border: 0;
        }
    }
}
</style>
